import React from 'react';
import Main from 'views/layouts/Main/Main'; // Ensure this is the correct import path for your Main component

import AllAssessments from './AllAssessments';

const DiagnosticScreeningServices = () => {
	return (
		<Main sx={{ boxShadow: 0 }}>
			<AllAssessments />
		</Main>
	);
};

export default DiagnosticScreeningServices;
